import { ConductionMethod } from '../conduction-method';
export function shouldConductByAccountByDefault(globalDefaults) {
    return (globalDefaults.conductionMethod === ConductionMethod.OwnerAccount &&
        globalDefaults.siteOwnerId &&
        globalDefaults.loggedInUserId);
}
export function getGlobalRequestContext(globalDefaults) {
    if (shouldConductByAccountByDefault(globalDefaults)) {
        return {
            forSiteOwner: {
                siteOwnerId: globalDefaults.siteOwnerId,
                loggedInUserId: globalDefaults.loggedInUserId,
            },
        };
    }
    return {};
}
//# sourceMappingURL=global-defaults-checks.js.map